'use client';

import Link from 'next/link';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

export default function TermsConditionsPage() {
  return (
    <>
      <Header />
      <main className="bg-gray-950 min-h-screen pt-24 pb-16">
        <div className="container mx-auto px-6 max-w-4xl">
          {/* Page Header */}
          <div className="mb-10">
            <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">TERMS OF SERVICE</h1>
            <p className="text-white font-semibold text-lg">E-GREGOR GROUP LTD</p>
            <p className="text-gray-400 mt-3 leading-relaxed">
              This <span className="text-blue-400 font-medium">TERMS OF SERVICE</span> was last updated on April 1, 2026.
            </p>
          </div>

          <div className="space-y-10 text-gray-300">

            {/* 1. Introduction */}
            <section>
              <h2 className="text-xl font-semibold text-blue-400 mb-3">1. Introduction</h2>
              <p className="leading-relaxed mb-2">
                Welcome to E-GREGOR GROUP LTD (&quot;we&quot;, &quot;us&quot;, &quot;our&quot;).
              </p>
              <p className="leading-relaxed mb-2">
                These Terms of Service (&quot;Terms&quot;) govern your use of our website and services (collectively, the &quot;Services&quot;). By accessing or using our Services, you agree to be bound by these Terms.
              </p>
              <p className="leading-relaxed">
                If you do not agree, you must not use our Services.
              </p>
            </section>

            {/* 2. About Us */}
            <section>
              <h2 className="text-xl font-semibold text-blue-400 mb-3">2. About Us</h2>
              <ul className="space-y-1 text-gray-300">
                <li className="font-semibold text-white">E-GREGOR GROUP LTD</li>
                <li>Address: 20 WENLOCK ROAD LONDON ENGLAND N1 7GU</li>
                <li>Company Number: 16994451</li>
                <li>
                  Email:{' '}
                  <a href="mailto:sales@egregor.cc" className="text-blue-400 hover:underline">
                    sales@egregor.cc
                  </a>
                </li>
              </ul>
            </section>

            {/* 3. Eligibility */}
            <section>
              <h2 className="text-xl font-semibold text-blue-400 mb-3">3. Eligibility</h2>
              <p className="leading-relaxed">
                You must be at least 18 years old and legally capable of entering into binding contracts to use our Services.
              </p>
            </section>

            {/* 4. Services */}
            <section>
              <h2 className="text-xl font-semibold text-blue-400 mb-3">4. Services</h2>
              <p className="leading-relaxed mb-3">
                We provide IT and cybersecurity-related services, including but not limited to:
              </p>
              <ul className="space-y-1 pl-2 text-gray-300">
                <li>software development;</li>
                <li>IT consulting;</li>
                <li>cybersecurity services;</li>
                <li>system integration and support.</li>
              </ul>
              <p className="leading-relaxed mt-3">
                We reserve the right to modify or discontinue any part of the Services at any time.
              </p>
            </section>

            {/* 5. User Obligations */}
            <section>
              <h2 className="text-xl font-semibold text-blue-400 mb-3">5. User Obligations</h2>
              <p className="leading-relaxed mb-3">You agree to:</p>
              <ul className="space-y-1 pl-2 text-gray-300">
                <li>use the Services in compliance with applicable laws and regulations;</li>
                <li>not misuse, interfere with, or disrupt our systems;</li>
                <li>not attempt unauthorised access to any part of the Services;</li>
                <li>provide accurate and up-to-date information.</li>
              </ul>
            </section>

            {/* 6. Fees and Payments */}
            <section>
              <h2 className="text-xl font-semibold text-blue-400 mb-3">6. Fees and Payments</h2>
              <p className="leading-relaxed mb-3">Where Services are paid:</p>
              <ul className="space-y-1 pl-2 text-gray-300">
                <li>fees will be specified separately (e.g. contract, proposal, or pricing page);</li>
                <li>all payments must be made in GBP unless otherwise agreed;</li>
                <li>invoices must be paid within the agreed timeframe.</li>
              </ul>
              <p className="leading-relaxed mt-3">
                Failure to pay may result in suspension of Services.
              </p>
            </section>

            {/* 7. Intellectual Property */}
            <section>
              <h2 className="text-xl font-semibold text-blue-400 mb-3">7. Intellectual Property</h2>
              <p className="leading-relaxed mb-3">
                All content on the website (text, software, design, logos) is owned by or licensed to{' '}
                <strong className="text-white">E-GREGOR GROUP LTD</strong>.
              </p>
              <p className="leading-relaxed mb-2">You may not:</p>
              <ul className="space-y-1 pl-2 text-gray-300">
                <li>copy, reproduce, or distribute content without permission;</li>
                <li>reverse engineer or exploit any part of the Services.</li>
              </ul>
            </section>

          </div>

          {/* Back Link */}
          <div className="mt-12 pt-8 border-t border-zinc-800">
            <Link href="/" className="text-blue-400 hover:underline text-sm">
              &larr; Back to Home
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
